var PaymentStrategy = (function (_, PromiseUtil) {
	var PaymentStrategy = function () { };

	_.extend(PaymentStrategy.prototype, {
		beforeProcess: function () {
			return PromiseUtil.resolved.apply(PromiseUtil, arguments);
		},

		betweenProcessAndComplete: function () {
			return PromiseUtil.resolved.apply(PromiseUtil, arguments);
		},

		afterComplete: function () {
			return PromiseUtil.resolved.apply(PromiseUtil, arguments);
		},

		afterTryComplete: function () {
			return PromiseUtil.resolved.apply(PromiseUtil, arguments);
		}
	});

	return PaymentStrategy;
})(_, PromiseUtil);
